export default __webpack_public_path__ + "static/media/Thief's Bands of the Nadir.9af7100c.jpg";